import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { Link } from "react-router-dom";
import { IdentifierMapping, ROUTES } from "../../constants";
import { Employee } from "../../graphql/baseTypes";

interface Props {
  item: Employee;
  isLast?: boolean;
}

const EmployeeListItem: React.FC<Props> = ({ item, isLast }) => {
  return (
    <ListItem
      button
      divider={!isLast}
      component={Link}
      to={`${ROUTES.EMPLOYEES}/${item.locationId}/${item.insuranceNumber}`}
    >
      <ListItemText
        primary={`${IdentifierMapping[item.identifier || "insurance"]}: ${
          item.insuranceNumber
        }`}
        secondary={`${item.patient?.firstname} ${item.patient?.lastname}`}
      />
    </ListItem>
  );
};

export default EmployeeListItem;
